import { userInfoDetail } from '@/apis/index'
import { authStore, mergeUserInfo, setUser, getToken } from '@/utils/auth'

export async function fetchAndRefreshUser(phone = '') {
  if (!getToken()) return null

  try {
    const res = await userInfoDetail({})
    if (res && res.user) {
      const merged = mergeUserInfo(authStore.user || {}, res.user, phone || authStore.phone)
      setUser(merged)
      return merged
    }
  } catch (err) {
    console.error('[userSession] fetch user info failed', err)
  }

  return authStore.user
}
